function escapeHtml(html) {
  return String(html)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

function getHTMLString({ name, email, message, time, ipInfo }) {
  let tableRows = "";

  for (let key in ipInfo) {
    if (ipInfo.hasOwnProperty(key)) {
      tableRows += `<tr>`;
      tableRows += `<td><strong>${escapeHtml(key)}:</strong></td>`;
      tableRows += `<td>${escapeHtml(ipInfo[key])}</td>`;
      tableRows += `</tr>`;
    }
  }
  const html =
    `<div>` +
    `<p><strong>Name:</strong> ${escapeHtml(name)}</p>` +
    `<p><strong>Email:</strong> ${escapeHtml(email)}</p>` +
    `<p><strong>Message:</strong> ${escapeHtml(message)}</p>` +
    `<p><strong>Time:</strong> ${escapeHtml(time)}</p>` +
    `<table>${tableRows}</table>` +
    `</div>`;
  return html;
}

const sendMail = async ({ name, email, message, time, ipInfo }) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "text/plain",
    },
    body: getHTMLString({ name, email, message, time, ipInfo }),
  };
  const apiUrl = `https://personal-emailer-five.vercel.app/api/emailer?fromname=${name}&from=${email}`;

  try {
    await fetch(apiUrl, requestOptions);
  } catch (e) {
    console.log(e);
  }
};

export default sendMail;
